import {NewCheckVaultItemsProvider} from "@/components/context/NewCheckVaultItemsContextInterface.tsx";
import {useNewCheckVaultItems} from "@/components/context/NewCheckVaultItemsHookFunctions.ts";
import {TestRunnerProvider} from "@/components/context/TestRunnerContext.tsx";
import {ServiceVariableGroupByCredential} from "@/lib/types/serviceVariables.ts";
import {CreateCheckForm} from "@/pages/checks/update/CreateCheckForm.tsx";
import {CreateCheckFormProps} from "@/pages/checks/update/CreateCheckForm.types.ts";

interface CreateEditCheckProps extends CreateCheckFormProps {
  initialServiceVariables?: ServiceVariableGroupByCredential[];
}

export const CreateEditCheck = ({initialServiceVariables, service, ...rest}: CreateEditCheckProps) => {
  const newCheckVaultItemMethods = useNewCheckVaultItems(service?.id, initialServiceVariables);

  return (
    <NewCheckVaultItemsProvider {...newCheckVaultItemMethods}>
      <TestRunnerProvider>
        <CreateCheckForm service={service} {...rest} />
      </TestRunnerProvider>
    </NewCheckVaultItemsProvider>
  );
};
